import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17bed052")

_pushScopeId("data-v-17bed052")
const _hoisted_1 = { class: "ecuDetail_main" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ECU Inspection ")
const _hoisted_4 = { class: "baseInfo_main" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"ecu-introduce\" data-v-17bed052><div class=\"ecu-introduce-title\" data-v-17bed052> What is ECU Inspection? </div><div class=\"ecu-introduce-text\" data-v-17bed052> It involves connecting a diagnostic tool to the vehicle&#39;s OBD port to read data from the on-board computer. The data that can be read through this inspection includes the working conditions of core components such as the engine fuel system, emission control system, oxygen sensor, three-way catalyst, electronic control system, and transmission. Importantly, the ECU records whether any faults have occurred in various systems during operation, and any fault information will be stored in the system. </div></div><div class=\"ecu-title\" data-v-17bed052><div class=\"ecu-title-left\" data-v-17bed052> Vehicle Information <div class=\"title_line\" data-v-17bed052></div></div><div class=\"ecu-title-right\" data-v-17bed052></div></div>", 2)
const _hoisted_7 = { class: "ecu-content-base" }
const _hoisted_8 = { class: "ui_content_item" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" VIN ")
const _hoisted_10 = { class: "ui_content_item" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" License plate No ")
const _hoisted_12 = { class: "ui_content_item" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Vehicle Brand ")
const _hoisted_14 = { class: "ui_content_item" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Model Year ")
const _hoisted_16 = { class: "ui_content_item" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Model Name ")
const _hoisted_18 = { class: "ui_content_item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Mileage ")
const _hoisted_20 = { class: "ui_content_item" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Inspection Time ")
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_23 = { class: "check_items" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "ecu-items-title" }, [
  /*#__PURE__*/_createVNode("div", { class: "ecu-items-title-left" }, [
    /*#__PURE__*/_createTextVNode(" ECU Inspection Items "),
    /*#__PURE__*/_createVNode("div", { class: "title_line" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "ecu-title-right" })
], -1)
const _hoisted_25 = { class: "abnormal_main" }
const _hoisted_26 = { class: "ecu-title" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
  /*#__PURE__*/_createVNode("span", null, "Abnormal Items")
], -1)
const _hoisted_28 = { class: "ecu-content-abnormal" }
const _hoisted_29 = { class: "abnormal_list_item_flex" }
const _hoisted_30 = { class: "abnormal_list_item_left" }
const _hoisted_31 = { class: "abnormal_list_checkbox" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "abnormal_list_item_right" }, " Abnormal ", -1)
const _hoisted_33 = { class: "abnormal_list_item_center" }
const _hoisted_34 = { class: "abnormal_list_checkitem" }
const _hoisted_35 = {
  key: 0,
  class: "abnormal_list_box"
}
const _hoisted_36 = { class: "abnormal_code" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "abnormal_code_left" }, "Fault Code", -1)
const _hoisted_38 = { class: "abnormal_code_right" }
const _hoisted_39 = { class: "abnormal_des" }
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "abnormal_des_left" }, "Fault Description", -1)
const _hoisted_41 = { class: "abnormal_des_right" }
const _hoisted_42 = { class: "normal_main" }
const _hoisted_43 = { class: "ecu-title" }
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "ecu-title-left" }, [
  /*#__PURE__*/_createVNode("span", null, "Normal Items")
], -1)
const _hoisted_45 = { class: "ecu-content-normal" }
const _hoisted_46 = { class: "normal_list_item_flex" }
const _hoisted_47 = { class: "normal_list_item_left" }
const _hoisted_48 = { class: "normal_list_checkbox" }
const _hoisted_49 = /*#__PURE__*/_createVNode("div", { class: "normal_list_item_right" }, " Normal ", -1)
const _hoisted_50 = { class: "normal_list_item_center" }
const _hoisted_51 = { class: "normal_list_checkitem" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"line\" data-v-17bed052></div><div class=\"reminder_main\" data-v-17bed052><div class=\"reminder_title\" data-v-17bed052> Important Notice </div><div class=\"reminder_text\" data-v-17bed052> All vehicle operation data displayed in this inspection are static data, and the information is for reference only. 268V shall not be liable for any accidents or faults arising therefrom. </div></div><div class=\"line h30\" data-v-17bed052></div>", 3)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ecuDetail-header",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.vin), 1)
        ]),
        _createVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.license), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.brand), 1)
        ]),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.year), 1)
        ]),
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.modelName), 1)
        ]),
        _createVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.mile), 1)
        ]),
        _createVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode("span", null, _toDisplayString(_ctx.state.ecuBaseInfo.checkTime), 1)
        ])
      ])
    ]),
    _hoisted_22,
    _createVNode("div", _hoisted_23, [
      _hoisted_24,
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode("div", {
            class: "ecu-title-right",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeAbnormal && _ctx.changeAbnormal(...args)))
          }, [
            _createVNode("img", {
              class: "abnormal_icon",
              src: require('@/assets/promiseFrame/ecu-abnormal.png')
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.state.abnormalItemCount) + "项", 1),
            _createVNode("img", {
              class: "show_icon",
              src: require('@/assets/promiseFrame/ecu-down.png')
            }, null, 8, ["src"])
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_28, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.abnormalList, (itemfather) => {
            return (_openBlock(), _createBlock("div", {
              class: "abnormal_list_item",
              key: itemfather.index
            }, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _createVNode("p", _hoisted_31, _toDisplayString(itemfather.systemType), 1)
                  ]),
                  _hoisted_32
                ]),
                _createVNode("div", _hoisted_33, [
                  _createVNode("p", _hoisted_34, _toDisplayString(itemfather.systemName), 1)
                ])
              ]),
              (itemfather.items && itemfather.items.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_35, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemfather.items, (itemchild) => {
                      return (_openBlock(), _createBlock("div", {
                        class: "abnormal_list_box_item",
                        key: itemchild.faultCode
                      }, [
                        _createVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createVNode("div", _hoisted_38, _toDisplayString(itemchild.faultCode), 1)
                        ]),
                        _createVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createVNode("div", _hoisted_41, _toDisplayString(itemchild.faultDesc), 1)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.state.isAbnormal]
        ])
      ]),
      _createVNode("div", _hoisted_42, [
        _createVNode("div", _hoisted_43, [
          _hoisted_44,
          _createVNode("div", {
            class: "ecu-title-right",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.changeNormal && _ctx.changeNormal(...args)))
          }, [
            _createVNode("img", {
              class: "normal_icon",
              src: require('@/assets/promiseFrame/ecu-normal.png')
            }, null, 8, ["src"]),
            _createTextVNode(_toDisplayString(_ctx.state.normalItemCount) + "项", 1),
            _createVNode("img", {
              class: "show_icon",
              src: require('@/assets/promiseFrame/ecu-down.png')
            }, null, 8, ["src"])
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_45, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.normalList, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "normal_list_item",
              key: item.index
            }, [
              _createVNode("div", _hoisted_46, [
                _createVNode("div", _hoisted_47, [
                  _createVNode("p", _hoisted_48, _toDisplayString(item.systemType), 1)
                ]),
                _hoisted_49
              ]),
              _createVNode("div", _hoisted_50, [
                _createVNode("p", _hoisted_51, _toDisplayString(item.systemName), 1)
              ])
            ]))
          }), 128))
        ], 512), [
          [_vShow, _ctx.state.isNormal]
        ])
      ])
    ]),
    _hoisted_52
  ]))
})